import React from "react";
import { notification } from "antd";
import { useTranslation } from "react-i18next";

import { SectionTitle } from "./styledComponents";
import ActionLogDrawerAsync from "./ActionLogDrawerAsync";
import { TaxBoardTaxCase } from "../../api/graphql/schema.generated";
import EditableCustomerAttribute, {
  EditType,
} from "./EditableCustomerAttribute";
import { useSetBusinessSectionNotRelevantMutation } from "../../api/graphql/mutations/taxCase/setBusinessSectionNotRelevant.generated";

const RELEVANT = "relevant";
const NOT_RELEVANT = "notRelevant";

const BusinessQuestionnaire = ({
  taxCase,
  taxYear,
  onRefresh,
}: {
  taxCase: TaxBoardTaxCase;
  taxYear: number;
  onRefresh?: () => void;
}) => {
  const { t } = useTranslation("TaxCaseOverview");
  const [setBusinessSectionNotRelevant] =
    useSetBusinessSectionNotRelevantMutation();

  const formatValue = (value: string) =>
    value === NOT_RELEVANT ? t("notRelevant") : t("relevant");

  const ids = [taxCase.id];
  const subTexts = { [taxCase.id]: `Year: ${taxYear}` };

  return (
    <>
      <SectionTitle>
        <span>{t("businessQuestionnaires")}</span>
        <ActionLogDrawerAsync
          title={t("businessQuestionnaires")}
          modelName="tax_case"
          recordIds={ids}
          subTexts={subTexts}
          selectedFields={["businessSectionNotRelevantAt"]}
          small
        />
      </SectionTitle>
      <EditableCustomerAttribute
        label={`${t("businessQuestionnaires")} ${taxYear}`}
        initialValue={
          taxCase.businessSectionNotRelevantAt ? NOT_RELEVANT : RELEVANT
        }
        editType={EditType.Select}
        options={[RELEVANT, NOT_RELEVANT]}
        formatFunction={formatValue}
        onSaveHandler={async (value: string) => {
          try {
            const result = await setBusinessSectionNotRelevant({
              variables: {
                payload: {
                  taxCaseId: taxCase.id,
                  notRelevant: value === NOT_RELEVANT,
                },
              },
            });
            if (result.data?.setBusinessSectionNotRelevant?.success) {
              notification.success({ message: t("setNotRelevantSuccess") });
              onRefresh?.();
            } else {
              notification.error({ message: t("setNotRelevantError") });
            }
          } catch {
            notification.error({ message: t("setNotRelevantError") });
          }
        }}
      />
    </>
  );
};

export default BusinessQuestionnaire;
